import { render } from "./studioNews.vue?vue&type=template&id=1ba73580&scoped=true"
import script from "./studioNews.vue?vue&type=script&lang=js"
export * from "./studioNews.vue?vue&type=script&lang=js"

import "./studioNews.vue?vue&type=style&index=0&id=1ba73580&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba73580"]])

export default __exports__